import React, { FunctionComponent, useState, useEffect } from 'react';
import CallModal from 'app/components/call/CallModal';
import FlexMarginGroup from 'app/components/layout/FlexMarginGroup';
import { useI18n } from 'app/components/localization';
import { ButtonA, ColorScheme } from 'app/components/presentation/buttons/ButtonClassNameA';
import { usePasteChatImageContext } from 'app/containers/rtc/PasteChatImageContext';
import LoadingButtonA from '../presentation/buttons/LoadingButtonA';

const ImageFilePreview: FunctionComponent<{ file: Blob }> = ({ file }) => {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    const lastSrc = URL.createObjectURL(file);

    setSrc(lastSrc);

    return () => {
      URL.revokeObjectURL(lastSrc);
    };
  }, [file, setSrc]);

  if (!src) {
    return null;
  }

  return <img src={src} alt="" style={{ maxWidth: '100%' }} />;
};

const ImageUploadModal: FunctionComponent = () => {
  const { file, uploading, removeFile, handleUpload } = usePasteChatImageContext();
  const { t } = useI18n();

  if (!file) {
    return null;
  }

  return (
    <CallModal
      onClose={removeFile}
      title={t('rtc.chat.file-upload-modal.title')}
      buttons={
        <FlexMarginGroup wrap center>
          <ButtonA colorScheme={ColorScheme.Secondary} onClick={removeFile} disabled={uploading}>
            {t('rtc.chat.file-upload-modal.cancel')}
          </ButtonA>
          <LoadingButtonA onClick={handleUpload} isLoading={uploading} disabled={uploading}>
            {t('rtc.chat.file-upload-modal.upload')}
          </LoadingButtonA>
        </FlexMarginGroup>
      }
    >
      <ImageFilePreview file={file} />
    </CallModal>
  );
};

export default ImageUploadModal;
